"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZLeaderboardPrizeDetails = exports.ZLeaderboardAction = void 0;
const dbEnums_1 = require("@daymade/common-lib/dbEnums");
const zod_1 = require("zod");
const prize_1 = require("../../prize");
exports.ZLeaderboardAction = zod_1.z.nativeEnum(dbEnums_1.LeaderboardAction);
exports.ZLeaderboardPrizeDetails = prize_1.ZPrizeSelect.pick({
    id: true,
    title: true,
    imageLocations: true,
    whatsIncludedBody: true,
});
//# sourceMappingURL=models.js.map